import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import {
    Chart,
    Interval,
    Axis,
    Tooltip,
    Coordinate,
} from "bizcharts";
import DataSet from "@antv/data-set";

const getChunks = (array, chunk_size) => Array(Math.ceil(array.length / chunk_size)).fill().map((_, index) => index * chunk_size).map(begin => array.slice(begin, begin + chunk_size));

const Samples = (props) => {
    let data;
    let chunks;
    let scale;
    const height = props.chunkSize === 3 ? 100 : 130;

    if (props.data) {
        data = props.data.data;
        chunks = getChunks(data, props.chunkSize);
        scale = {
            'Samples': {
                min: 0,
                max: Math.max(...props.data.data.map(d => d['Samples']))
            }
        }
    }


    useEffect(() => { }, [data]);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })
    return (
        <Box>
            <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.5rem' }}><b>Number of samples per food group</b></p>
            <Box display='flex' >
                {
                    props.data &&
                    chunks.map((c, idx) => {
                        const ds = new DataSet();
                        const dv = ds.createView().source(c);
                        return (
                            < Box key={idx} ml={'10px'} >
                                <Chart
                                    scale={scale}
                                    data={dv}
                                    height={height}
                                    width={92}
                                    autoFit
                                >
                                    <Coordinate transpose />
                                    <Axis name="Samples" visible={false} />
                                    <Axis name="Food commodity" visible={false} />
                                    <Tooltip visible={false} />
                                    <Interval color='#246898' label={{
                                        fields: ['Samples', 'Food commodity'],
                                        cfg: {
                                            position: 'left',
                                            offsetY: -10,
                                            offsetX: -14,
                                            style: {
                                                fontFamily: 'Roboto Condensed, sans-serif'
                                            }
                                        },
                                        callback: (samples, commodity) => {
                                            return {
                                                content: commodity + ': ' + samples,
                                            }
                                        }
                                    }} size={7} style={{ height: 10 }} position="Food commodity*Samples" />
                                </Chart>
                            </Box>
                        )

                    })
                }
            </Box>
        </Box >

    );
}

export default Samples;